import { LinearSlideStyle, Slider } from "@fp/react-slider"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

import { useTranslation, withTranslation } from "../../i18n/translate"
import { dynamicImageWithGatsbyImage } from "../../util/dynamic-image"
import {
  getDynamicPdfFileUrl,
  getPdfFileItemForLanguage,
} from "../dynamic-pdf-file/dynamic-pdf-file"
import "./image-slider.sass"
import SliderIndicators from "./slider-indicators/slider-indicators"

class ImageSlider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0,
      goToIndex: () => {},
    }
  }

  render() {
    const items = this.props.items || []
    const locale = this.props.i18n.language || "en"

    return (
      <div style={{ position: "relative" }}>
        <div className={"_fp-image-slider"}>
          <Slider
            onSlideChange={(index) => {
              this.setState({ activeIndex: index })
            }}
            onMount={({ goToIndex }) => {
              this.setState({ goToIndex })
            }}
            slideStyle={new LinearSlideStyle()}
            interval={10000}
          >
            {items.map((item, index) => {
              return (
                <div key={`slide_${index}`} className="_fp-image-slider__slide">
                  <GatsbyImage
                    imgStyle={{ objectFit: "cover", objectPosition: "center" }}
                    style={{ height: "100%" }}
                    image={item.image}
                    alt={`Image-Slider Slide ${index}`}
                  />
                </div>
              )
            })}
          </Slider>
          <SliderIndicators
            items={items}
            activeIndex={this.state.activeIndex}
            goToIndex={this.state.goToIndex}
          />
        </div>
        <div className="_fp-image-slider__badges">
          <img
            className={"_fp-image-slider-badge"}
            src="/images/hero/ecovadis-medal.png"
            alt="EcoVadis Gold Medal"
          />

          <img
            className={"_fp-image-slider-badge"}
            src="/images/Munster_Excellence_MUNZING_Group_EN.png"
            alt="Munster Excellence"
          />

          <img
            className={"_fp-image-slider-badge"}
            src="/images/Leading_Company_Siegel_MUNZING_GroupESG.png"
            alt="ESG Transparency Award"
          />
        </div>
      </div>
    )
  }
}

export default withTranslation()(ImageSlider)
